import { LinkProps } from '@tanstack/react-router';

export const typedTo = (to: LinkProps['to']) => to!;
